import { Reducer } from "redux";

import { DownLoadNotesResponse } from "../models/Api/Notes";
import { DownLoadNotesDispatchTypes } from "../models/DispatchTypes/Notes";
import { DownloadNoteActionDispatchTypes } from "../constants/Notes";

export const initialState: DownLoadNotesResponse = {
  loading: false,
  response: [
    {
      noteEntryId: -1,
      noteTemplateId: -1,
      noteEntryJson: "",
      templateVersionId: -1,
      templateName: "",
      fullNameCreated: "",
    },
  ],
};

const DownloadNotesReducer: Reducer<
  DownLoadNotesResponse,
  DownLoadNotesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DownloadNoteActionDispatchTypes.POST_DOWNLOAD_NOTES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DownloadNoteActionDispatchTypes.POST_DOWNLOAD_NOTES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DownloadNoteActionDispatchTypes.POST_DOWNLOAD_NOTES_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DownloadNotesReducer;
